// extracted by mini-css-extract-plugin
export default {"content":"styles_content__7zVje","contentAnimation":"styles_contentAnimation__axO4o"};